<template>
  <div
      :class="[
      isFullScreen ? 'full-screen' : 'half-screen',
      'docInteract',
      'history-action'
    ]"
  >
    <div>
      <div class="panel-header flex-row  flex__between has-border__bottom">
        <p class="title font-weight__bold">Lịch sử</p>
        <div class="btn__action">
          <i class="fas fa-expand item clickable" @click="changeView"></i>
          <i
              class="fas fa-times item clickable"
              @click="$emit('closeHistory')"
          ></i>
        </div>
      </div>

      <VuePerfectScrollbar
          class="scroll-history"
          :settings="perfectScrollbarSetting"
      >
        <div :class="['panel-body', 'list__action']">
          <template v-for="action in histories">
            <vb-outgoing-doc-sua-sai-action-log
                v-if="
                action.actionName ===
                  ACTION_LOG_ACTION_NAME.VB_OUTGOING_DOC.SUA_SAI
              "
                :key="action.id"
                :actionLog="action.data"
            ></vb-outgoing-doc-sua-sai-action-log>
            <div v-else :key="action.id" class="list__action__item">
              <template
                  v-if="
                  action.actionName === ACTION_LOG_ACTION_NAME.BANHANH_TOI ||
                    action.actionName === ACTION_LOG_ACTION_NAME.BANHANHV2 ||
                    action.actionName === ACTION_LOG_ACTION_NAME.DA_NHAN ||
                    action.actionName === ACTION_LOG_ACTION_NAME.CHOYKIEN ||
                    action.actionName === ACTION_LOG_ACTION_NAME.DA_DEN ||
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN ||
                    action.actionName === ACTION_LOG_ACTION_NAME.TIEP_NHAN ||
                    action.actionName === ACTION_LOG_ACTION_NAME.PHAN_CONG ||
                    action.actionName === ACTION_LOG_ACTION_NAME.DANG_XU_LY ||
                    action.actionName === ACTION_LOG_ACTION_NAME.HOAN_THANH ||
                    action.actionName === ACTION_LOG_ACTION_NAME.DONG_Y ||
                    action.actionName === ACTION_LOG_ACTION_NAME.TU_CHOI ||
                    action.actionName === ACTION_LOG_ACTION_NAME.TRA_LAI ||
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH ||
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.TU_CHOI_TRA_LAI ||
                    action.actionName === ACTION_LOG_ACTION_NAME.HIEUCHINHV2 ||
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.THUHOI_BANHANHV2
                "
              >
                <div>
                  <div
                      class="avatar-fake margin-right-10 flex-row flex__center"
                  >
                    <span>{{ buildShortName(action.creatorName) }}</span>
                  </div>
                </div>
                <history-banhanhtoi
                    v-if="
                    action.actionName === ACTION_LOG_ACTION_NAME.BANHANH_TOI ||
                      action.actionName === ACTION_LOG_ACTION_NAME.BANHANHV2
                  "
                    :action="action"
                ></history-banhanhtoi>
                <history-danhan-tltvb
                    v-else-if="
                    action.actionName === ACTION_LOG_ACTION_NAME.DA_DEN
                  "
                    :action="action"
                >
                </history-danhan-tltvb>
                <history-cho-y-kien
                    v-else-if="
                    action.actionName === ACTION_LOG_ACTION_NAME.CHOYKIEN
                  "
                    :action="action"
                ></history-cho-y-kien>
                <history-status-tltvb
                    v-else-if="
                    action.actionName === ACTION_LOG_ACTION_NAME.DA_DEN ||
                      action.actionName === ACTION_LOG_ACTION_NAME.DA_NHAN ||
                      action.actionName ===
                        ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN ||
                      action.actionName === ACTION_LOG_ACTION_NAME.TRA_LAI ||
                      action.actionName === ACTION_LOG_ACTION_NAME.TIEP_NHAN ||
                      action.actionName === ACTION_LOG_ACTION_NAME.PHAN_CONG ||
                      action.actionName === ACTION_LOG_ACTION_NAME.DANG_XU_LY ||
                      action.actionName === ACTION_LOG_ACTION_NAME.HOAN_THANH ||
                      action.actionName === ACTION_LOG_ACTION_NAME.DONG_Y ||
                      action.actionName === ACTION_LOG_ACTION_NAME.TU_CHOI ||
                      action.actionName ===
                        ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH ||
                      action.actionName ===
                        ACTION_LOG_ACTION_NAME.TU_CHOI_TRA_LAI
                  "
                    :action="action"
                ></history-status-tltvb>
                <history-hieuchinh
                    v-else-if="
                    action.actionName === ACTION_LOG_ACTION_NAME.HIEUCHINHV2
                  "
                    :action="action"
                ></history-hieuchinh>
                <history-thuhoi-banhanh
                    v-else-if="
                    action.actionName ===
                      ACTION_LOG_ACTION_NAME.THUHOI_BANHANHV2
                  "
                    :action="action"
                ></history-thuhoi-banhanh>
              </template>
              <template v-else>
                <div>
                  <div
                      class="avatar-fake margin-right-10 flex-row flex__center"
                  >
                    <span>{{ buildShortName(action.creatorName) }}</span>
                  </div>
                </div>
                <div class="list__action__item--content">
                  <div class="flex-row flex__between">
                    <p class="name margin-0">{{ action.creatorName }}</p>
                    <div class="time font-size__small">
                      <i class="fas fa-clock color__silver"></i>
                      {{ action.createTime | convertToLabelFilter }}
                    </div>
                  </div>
                  <div>
                    <p
                        v-if="action.dataType === 'actionLog'"
                        :class="[
                        'action-type inline-flex flex-row flex__left',
                        classColorByActionName(action.actionName)
                      ]"
                    >
                      <i
                          :class="[
                          'font-size__small',
                          classIconByActionName(action.actionName)
                        ]"
                      >
                      </i>
                      <span class="font-size__small no_wrap">
                        &nbsp;&nbsp;{{ action.actionNameLabel }}
                      </span>
                    </p>

                    <!-- diff: data receiverName or deptName (roleName) -->
                    <popoverWord
                        v-for="(item, $index) in buildNameReceivers(action).split(
                        ' '
                      )"
                        :key="$index"
                        :categoryVBan="'doc-out'"
                        :action="action"
                        :word="item"
                        :actionName="action.actionName"
                    />
                    <!-- same: va rest number don vi ( nguoi ) khac -->
                    <popoverWord
                        v-for="item in buildWordTemplate(action)"
                        :key="item"
                        :categoryVBan="'doc-out'"
                        :action="action"
                        :word="item"
                        :actionName="action.actionName"
                    />

                    <!--action && comment-->
                    <div
                        v-if="
                        action.dataType === 'actionLog' && action.data.comment
                      "
                        class="content__message--text content__message--item"
                    >
                      <el-input
                          v-if="action.data.comment"
                          type="textarea"
                          resize="none"
                          ref="inputComment"
                          autosize
                          v-model.trim="action.data.comment"
                          disabled
                          class="input-display__comment style-fullWidth input-none__border bg__transparent"
                      ></el-input>
                      <div
                          v-if="action.actionName === 'tuChoiGhiChuVb'"
                          @click="xemGhiChu(action)"
                          class="clickable inline-flex flex__left color__link font-size__small margin-top-5"
                      >
                        <i class="fal fa-file-edit font-size__small"></i>
                        &nbsp;&nbsp;
                        <span class="has-border__bottom">
                          Xem ghi chú
                        </span>
                      </div>
                    </div>

                    <!-- comment -->
                    <div
                        v-if="action.dataType === 'comment'"
                        class="content__message--text content__message--item"
                    >
                      <el-popover
                          v-if="action.toUsers && action.toUsers.length"
                          placement="top-start"
                          width="500"
                          trigger="click"
                          title="Danh sách: "
                      >
                        <div
                            v-for="(item, index) in action.toUsers"
                            :key="item.id"
                        >
                          <p class="select-signer">
                            {{ index + 1 }}.
                            <span>
                              {{ item.toFullName }}
                              <em class="font-weight__bold font-size__small"
                              >({{
                                  item.toPositionName + " - " + item.toDeptName
                                }})</em
                              >
                            </span>
                          </p>
                        </div>

                        <span slot="reference">
                          <span class="highlight--name clickable tt-1">
                            @{{ action.toUsers[0].toFullName }}
                            <span
                                v-if="action.toUsers && action.toUsers.length > 1"
                            >
                              và {{ action.toUsers.length - 1 }} người khác
                            </span>
                          </span>
                        </span>
                      </el-popover>
                      <el-input
                          v-if="action.data.content"
                          type="textarea"
                          resize="none"
                          ref="inputComment"
                          autosize
                          v-model.trim="action.data.content"
                          disabled
                          class="input-display__comment style-fullWidth input-none__border bg__transparent"
                      ></el-input>
                    </div>
                    <!-- comment:end -->
                    <!-- attachment -->
                    <action-log-attachments
                        v-if="action.attachments && action.attachments.length"
                        :action="action"
                        class="plainFile"
                    >
                    </action-log-attachments>
                    <!-- attachment:end -->
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
        <DialogNoteInDocs
            v-if="isOpenNoteInDocDialog"
            :isOpen="isOpenNoteInDocDialog"
            :attachmentMetaId="attachmentMetaId"
            :isWatchingNote="true"
            :isAddSignature="false"
            :listPageNumberChange="listPageNumberChange"
            @closed="isEnableNoteInDocDialog = false"
            @closeDialog="isOpenNoteInDocDialog = false"
        />
      </VuePerfectScrollbar>

      <div id="detail-footer" class="panel-footer" v-if="isEnableComment">
        <div ref="commentArea" :class="['active', 'input-comment']">
          <div
              ref="toUsersArea"
              :class="[
              !isActiveToUsers ? 'fixHeightReceiver' : '',
              'toReceiver',
              'flex-row',
              'flex__between'
            ]"
          >
            <el-select
                ref="toUserSelectDropdown"
                v-show="isActiveToUsers"
                :class="['input-none__border', 'selectListReceiver']"
                v-model="toUserIds"
                placeholder="Gõ email/tên/chức vụ/sđt/đơn vị để tìm kiếm"
                size="medium"
                multiple
                filterable
                clearable
                remote
                reserve-keyword
                @remove-tag="removeUser"
                :remote-method="remoteSearchToUser"
                @visible-change="toUserSelectDropdownVisibleChange"
            >
              <el-option
                  v-for="item in toUsers"
                  :key="item.id"
                  :label="item.fullName"
                  :value="item.id"
              >
                <p class="select-signer">
                  <span>
                    {{ item.fullName }}
                    <em class="">{{
                        item.positionName + " - " + item.deptName
                      }}</em>
                  </span>
                </p>
              </el-option>
            </el-select>

            <div
                class="display-represent clickable"
                v-show="!isActiveToUsers"
                @click="isActiveToUsers = true"
            >
              <p
                  class="margin-0"
                  v-if="selectedToUsers && selectedToUsers.length"
              >
                <span>
                  <strong>{{ selectedToUsers[0].fullName }}</strong>
                </span>
                <span v-show="selectedToUsers.length > 1">
                  &nbsp;và {{ selectedToUsers.length - 1 }} người khác..</span
                >
              </p>
              <span
                  v-if="!selectedToUsers || !selectedToUsers.length"
                  class="placeholder-fake flex-row flex__left"
              >Người nhận</span
              >
            </div>
<!--            <i class="color__silver fas fa-user-circle"></i>-->
            <el-tag  :type="checkAll ? 'success' : 'info'" size="small"  @click="selectAll"
                     :style="{ cursor: 'pointer' }"
            >
              Tất cả
            </el-tag>
          </div>
          <!-- toUsers:end -->
          <!-- commentInput: -->
          <div>
            <transition name="el-fade-in-linear">
              <el-input
                  type="textarea"
                  resize="none"
                  ref="inputComment"
                  :rows="3"
                  placeholder="Nội dung bình luận"
                  v-model="content"
                  class="text-input-comment"
              ></el-input>
            </transition>
          </div>
          <!-- commentInput:end -->
          <!-- commentAttachment: -->
          <div class="action-comment flex-row flex__between">
            <div class="action-file">
              <el-upload
                  ref="fileDialog"
                  :action="uploadAttachmentURL"
                  :headers="uploadAttachmentHeaders"
                  :on-success="
                  response =>
                    onUploadSuccess(response).then(response =>
                      uploadAttachmentSuccess(response)
                    )
                "
                  :data="uploadAttachmentAdditionalData()"
                  :show-file-list="false"
                  :before-upload="
                  file => validateUploadFile(file, { acceptFileTypes: ['*'] })
                "
                  :on-error="onUploadError"
                  v-loading="isUploading"
              >
                <i class="fal fa-paperclip icon-action-comment clickable"></i>
              </el-upload>
            </div>
            <div
                class="clickable btn-send-comment font-weight__bold"
                @click="insertComment"
            >
              GỬI
            </div>
          </div>
          <!-- commentAttachment:end -->
        </div>
        <div
            v-if="vbAttachments"
            class="group-info el-upload-list el-upload-list--text"
        >
          <div
              v-for="vbAttachment in vbAttachments"
              :key="vbAttachment.id"
              class="flex-row flex__between file-item el-upload-list__item is-success"
          >
            <div class="flex-row flex__left inline-flex">
              <a
                  v-openInNewTab
                  :href="
                  getToken(vbAttachment.id)
                    | buildAttachmentURL({
                      type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                    })
                "
                  class="link-file"
              >
                <fileTypeImage
                    :fileExtention="vbAttachment.fileExtention"
                    :customClass="'icon-mini'"
                />
                <span class="link-file clickable font-size__small">{{
                    vbAttachment.fileName
                  }}</span>
              </a>
            </div>
            <label class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check"></i>
            </label>
            <i
                class="el-icon-close el-tooltip item clickable font-size__small color__red"
                @click="removeVbAttachment(vbAttachment)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "../../constants";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter.js";
import dateFormatter from "../../filters/dateFormatter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import actionLogService from "../../services/actionLogService";
import attachmentService from "../../services/attachmentService";
import h from "../../services/h";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import utils from "../../services/utils";
import vbCommentService from "../../services/vbCommentService";
import vbCommentToUserViewService from "../../services/vbCommentToUserViewService.js";
import ActionLogAttachments from "../doc-in/actionLogAttachments";
import HistoryBanhanhtoi from "../doc-in/history-banhanhtoi";
import HistoryChoYKien from "../doc-in/history-cho-y-kien";
import HistoryDanhanTltvb from "../doc-in/history-danhan-tltvb";
import HistoryHieuchinh from "../doc-in/history-hieuchinh";
import HistoryStatusTltvb from "../doc-in/history-status-tltvb";
import HistoryThuhoiBanhanh from "../doc-in/history-thuthoi-banhanh";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import VbOutgoingDocSuaSaiActionLog from "./vb-outgoing-doc-sua-sai-action-log";
import {EventBus} from "../../event-bus.js";

export default {
  name: "history-docout",
  mixins: [handleRequestErrorMixin, uploadFileMixin, vbAttachmentTokenMixin],
  props: ["vbOutgoingDocId", "isEnableComment", "isConfigLD", "isForBlockedRole"],
  components: {
    VbOutgoingDocSuaSaiActionLog,
    HistoryThuhoiBanhanh,
    HistoryHieuchinh,
    HistoryChoYKien,
    HistoryStatusTltvb,
    HistoryDanhanTltvb,
    HistoryBanhanhtoi,
    ActionLogAttachments,
    fileTypeImage: () => import("../common/FileTypeImage"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    popoverWord: () => import("../common/popoverWord"),
    DialogNoteInDocs: () => import("../common/noteDocs/index")
  },
  filters: {dateFormatter, convertToLabelFilter, buildAttachmentURL},

  watch: {
    isFullScreen() {
      return this.isFullScreen;
    },

    vbOutgoingDocId() {
      this.loadData();
      this.loadToUsers(null);
    },

    isToUsersFocused(newValue) {
      this.isActiveToUsers = newValue || this.isToUserSelectDropdownVisible;
    },

    isToUserSelectDropdownVisible() {
      this.isActiveToUsers =
          this.isToUsersFocused || this.isToUserSelectDropdownVisible;
    },

    isActiveToUsers(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.$refs.toUserSelectDropdown.focus();
        });
      }
    },

    toUserIds(newValue) {
      if (newValue && newValue.length) {
        userDeptRoleViewService
            .findAllByIdIn(newValue)
            .then(response => (this.selectedToUsers = response.data));
      } else {
        this.selectedToUsers = [];
      }
    },

    isOpenNoteInDocDialog(newValue) {
      newValue && (this.isEnableNoteInDocDialog = newValue);
    }
  },

  computed: {
    blockedUserId() {
      if (this.$store.getters.lockedUserDeptRole)
        return this.$store.getters.lockedUserDeptRole.userId
    },

    tenantCode(){
      return this.$store.getters.userDeptRole.tenantCode;
    },
  },

  data() {
    return {
      listPageNumberChange: [],
      vbAttachmentId: null,

      isOpenNoteInDocDialog: false,
      isEnableNoteInDocDialog: false,

      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      listFile: [],
      isFullScreen: false,
      form: {
        comment: "",
        listReceiver: []
      },
      isFocusSelectReceiver: false,
      histories: [],
      toUserIds: [],
      toUsers: [],
      selectedToUsers: [],
      content: null,
      commentToUsers: [],
      actionLogs: [],
      comments: [],
      isToUsersFocused: false,
      isActiveToUsers: false,
      isToUserSelectDropdownVisible: false,
      vbAttachments: [],
      commentVbAttachments: [],
      ACTION_LOG_ACTION_NAME: constants.ACTION_LOG_ACTION_NAME,
      checkAll: false
    };
  },

  created() {
    this.loadData();
    this.loadToUsers();
  },

  methods: {
    remoteSearchToUser(query) {
      this.loadToUsers(query);
    },

    xemGhiChu(action) {
      this.isOpenNoteInDocDialog = true;
      this.listPageNumberChange = action.dataJson.listPageNumberChange;
      this.attachmentMetaId = action.dataJson.attachmentMetaId;
    },

    buildWordTemplate: function (action) {
      let templateWord = [];
      if (
          action.dataType === "actionLog" &&
          action.dataJson &&
          action.dataJson.length > 1
      ) {
        if (
            action.actionName === constants.ACTION_LOG_ACTION_NAME.BANHANH_CANHAN ||
            action.actionName === constants.ACTION_LOG_ACTION_NAME.HIEUCHINH_BANHANH_CANHAN ||
            action.actionName === constants.ACTION_LOG_ACTION_NAME.CC
        ) {
          templateWord = [
            "và",
            (action.dataJson.length - 1).toString(),
            "người",
            "khác"
          ];
        } else {
          templateWord = [
            "và",
            (action.dataJson.length - 1).toString(),
            "đơn",
            "vị",
            "khác"
          ];
        }
      } else {
        templateWord = [];
      }
      return templateWord;
    },

    buildNameReceivers(action) {
      if (
          action.actionName &&
          action.dataType === "actionLog" &&
          action.dataJson
      ) {
        switch (action.actionName) {
          case "chuyenXuLi":
          case "kySoChuyenXuLi":
            return action.dataJson.receiverName;
          case "thuHoiBanHanh":
          case "banHanh":
          case "hieuChinhBanHanh":
            return action.dataJson && action.dataJson[0]
                ? action.dataJson[0].toDeptName || action.dataJson[0].deptName
                : "-";
          case "cc":
          case "banHanhCaNhan":
          case "hieuChinhBanHanhCaNhan":
            return action.dataJson[0] ? action.dataJson[0].receivedName : "";
          default:
            return "";
        }
      }
      return "";
    },

    removeVbAttachment(vbAttachment) {
      this.vbAttachments.splice(this.vbAttachments.indexOf(vbAttachment), 1);
    },

    uploadAttachmentAdditionalData() {
      return {objectType: constants.ATTACHMENT_OBJECT_TYPE.COMMENT};
    },

    uploadAttachmentSuccess(vbAttachment) {
      this.vbAttachments.push(vbAttachment);
    },

    loadToUsers(query) {
      userDeptRoleViewService
          .findAllByVbOutgoingDoc(this.vbOutgoingDocId, query, {
            sort: "fullName",
            page: 0,
            size: 100
          })
          .then(response => (this.toUsers = response.data));
    },

    loadData() {
      this.loadActionLogs().then(() =>
          this.loadComments().then(() =>
              this.loadCommentToUsers(this.comments).then(commentToUsers => {
                this.commentToUsers = commentToUsers;
                this.loadCommentVbAttachments(this.comments).then(vbAttachments => {
                  this.commentVbAttachments = vbAttachments;
                  this.mixToHistories();
                });
              })
          )
      );
    },

    loadCommentVbAttachments(comments) {
      let commentIds = h.collect(comments, comment => comment.id);
      return commentIds && commentIds.length
          ? attachmentService
              .findAllByComments(commentIds, {
                sort: "createTime,desc",
                page: 0,
                size: 1000
              })
              .then(response => response.data)
          : new Promise(resolve => resolve([]));
    },

    loadCommentToUsers(comments) {
      let commentIds = h.collect(comments, comment => comment.id);
      return commentIds && commentIds.length
          ? vbCommentToUserViewService
              .findAll(
                  null,
                  {sort: "createTime,desc", page: 0, size: 1000},
                  commentIds
              )
              .then(response => response.data)
          : new Promise(resolve => resolve([]));
    },

    loadComments() {
      return vbCommentService
          .findAllBySenderIdOrReceiverId(
              this.vbOutgoingDocId,
              constants.COMMENT_OBJECT_TYPE.VB_DI,
              {sort: "createTime,desc", page: 0, size: 1000}
          )
          .then(response => (this.comments = response.data));
    },

    loadActionLogs() {
      const pageable = {
        sort: "createTime,desc",
        page: 0,
        size: 1000
      };
      let promise;
      if (this.isForBlockedRole) {
        promise =  actionLogService.findAllByVbOutgoingDocForBlockedRole(
          this.vbOutgoingDocId,
          this.blockedUserId,
          pageable
        )
      }
      else if (this.isConfigLD) {
        promise = actionLogService.findAllByVbOutgoingDocForCongigLD(this.vbOutgoingDocId, {
          pageable
          })
      } else {
        promise = actionLogService.findAllByVbOutgoingDoc(this.vbOutgoingDocId, {
          pageable
          })
      }
      return promise.then(response => (this.actionLogs = response.data));
    },

    changeView() {
      this.isFullScreen = !this.isFullScreen;
    },

    insertComment() {
      /**
       * validate comment;
       */
      if (!this.content || !this.content.trim()) {
        this.$message({
          message: "Nội dung bình luận chưa được nhập",
          type: "error"
        });
        return;
      }

      // if (this.tenantCode !== "vinataba.com.vn" && (!this.selectedToUsers || !this.selectedToUsers.length)) {
      //   this.$message({
      //     message: "Chưa có người nhận được chọn",
      //     type: "error"
      //   });
      //   return;
      // }

      let vbCommentToUserForms = h.collect(this.selectedToUsers, item => {
        return {
          userId: item.userId,
          deptId: item.deptId,
          roleId: item.roleId,
          positionId: item.positionId,
          userDeptRoleId: item.id
        };
      });
      let attachmentIds = h.collect(this.vbAttachments, item => item.id);

      vbCommentService
          .insert({
            objectId: this.vbOutgoingDocId,
            objectType: constants.COMMENT_OBJECT_TYPE.VB_DI,
            content: this.content,
            vbCommentToUserForms: vbCommentToUserForms,
            attachmentIds: attachmentIds
          })
          .then(response => {
            let comment = response.data;

            /**
             * reset lại form nhập comment;
             */
            this.isActiveToUsers = false;
            this.content = "";
            this.toUserIds = [];
            this.vbAttachments = [];

            this.comments.push(comment);
            this.loadCommentToUsers([comment]).then(commentToUsers => {
              this.loadCommentVbAttachments([comment]).then(vbAttachments => {
                /**
                 * binding lại danh sách lịch sử, không query lại toàn bộ ảnh hưởng tới performance;
                 */
                this.commentToUsers.push(...commentToUsers);
                this.commentVbAttachments.push(...vbAttachments);
                this.histories.splice(
                    0,
                    0,
                    this.convertCommentToHistory(comment)
                );
              });
            });
          })
          .catch(error => this.commonHandleRequestError(error));
    },

    toUserSelectDropdownVisibleChange(event) {
      this.isToUserSelectDropdownVisible = event;
    },

    buildShortName(fullName) {
      return utils.buildShortName(fullName);
    },

    buildActionLabel(history) {
      if (history.dataType === "actionLog") {
        switch (history.actionName) {
          case constants.ACTION_LOG_ACTION_NAME.INSERT:
            return "Tạo mới";
          case constants.ACTION_LOG_ACTION_NAME.UPDATE:
            return "Cập nhật";
          case constants.ACTION_LOG_ACTION_NAME.CHUYENXULI:
            return "Chuyển xử lý đến";
          case constants.ACTION_LOG_ACTION_NAME.KYSO_CHUYENXULI:
            return "Ký duyệt và chuyển xử lý đến";
          case constants.ACTION_LOG_ACTION_NAME.CHOBANHANH:
            return "Duyệt ban hành";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOI:
            return "Từ chối";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOIBANHANH:
            return "Từ chối ban hành";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOI_GHICHU_VB:
            return "Từ chối văn bản đính kèm";
          case constants.ACTION_LOG_ACTION_NAME.BANHANH:
            return "Ban hành văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.KETTHUC:
            return "Kết thúc";
          case constants.ACTION_LOG_ACTION_NAME.THUHOI:
            return "Thu hồi";
          case constants.ACTION_LOG_ACTION_NAME.THUHOI_BANHANH:
            return "Thu hồi văn bản từ";
          case constants.ACTION_LOG_ACTION_NAME.CC:
            return "CC văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.BANHANH_CANHAN:
            return "Ban hành văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.HIEUCHINH_BANHANH_CANHAN:
            return "Hiệu chỉnh và ban hành văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.HIEUCHINH:
            return "Hiệu chỉnh văn bản";
          case constants.ACTION_LOG_ACTION_NAME.HIEUCHINH_BANHANH:
            return "Hiệu chỉnh và ban hành văn bản đến";
          case constants.ACTION_LOG_ACTION_NAME.TUCHOITIEPNHAN:
            return "Từ chối tiếp nhận văn bản ";
          case constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI:
            return "Từ chối";
          case constants.ACTION_LOG_ACTION_NAME.DA_DEN:
            return "Văn bản đã đến bên nhận";
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN:
            return "Văn bản đã bị từ chối";
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI:
            return "Văn bản đã bị từ chối lấy lại";
          case constants.ACTION_LOG_ACTION_NAME.DONG_Y:
            return "Văn bản đã được đồng ý lấy lại";
          case constants.ACTION_LOG_ACTION_NAME.PHAN_CONG:
            return "Văn bản đã được phân công";
          case constants.ACTION_LOG_ACTION_NAME.DANG_XU_LY:
            return "Văn bản đang được bên nhận xử lý";
          case constants.ACTION_LOG_ACTION_NAME.HOAN_THANH:
            return "Văn bản đã được bên nhận hoàn thành";
          default:
            return history.actionName;
        }
      } else {
        return "";
      }
    },

    loadCommentAttachment_(item) {
      item.attachments = h.findAll(
          this.commentVbAttachments,
          vbAttachment => vbAttachment.objectId == item.data.id
      );
    },

    loadCommentToUsers_(item) {
      item.toUsers = h.findAll(
          this.commentToUsers,
          commentToUser => commentToUser.commentId == item.data.id
      );
    },

    convertCommentToHistory(item) {
      let history = {
        id: item.id,
        actionName: item.actionName,
        creatorName: item.fromFullName || item.fromUserName,
        creatorId: item.fromUserId,
        createTime: item.createTime,
        dataType: "comment",
        data: item
      };

      history.actionNameLabel = this.buildActionLabel(history);

      this.loadCommentAttachment_(history);
      this.loadCommentToUsers_(history);

      return history;
    },

    mixToHistories() {
      let histories = (this.histories = []);

      h.each(this.actionLogs, item => {
        let history = {
          id: item.id,
          actionName: item.actionName,
          creatorName: item.creatorName,
          creatorId: item.creatorId,
          createTime: item.createTime,
          dataType: "actionLog",
          data: item,
          dataJson: item.hasOwnProperty("dataJson")
              ? JSON.parse(item.dataJson)
              : ""
        };

        history.actionNameLabel = this.buildActionLabel(history);

        histories.push(history);
        if (history.data.actionName == constants.ACTION_LOG_ACTION_NAME.TUCHOI
          || history.data.actionName == constants.ACTION_LOG_ACTION_NAME.TUCHOIBANHANH
          || history.data.actionName == constants.ACTION_LOG_ACTION_NAME.LANHDAO_TUCHOI){
          const data = history.data.comment;
          EventBus.$emit('commentSent', data);
        }
      });

      h.each(this.comments, item => {
        histories.push(this.convertCommentToHistory(item));
      });

      histories.sort((item1, item2) =>
          item1.createTime > item2.createTime
              ? -1
              : item1.createTime < item2.createTime
              ? 1
              : 0
      );
    },

    classIconByActionName(actionName) {
      return actionName == "update"
          ? "fas fa-pencil-alt"
          : actionName == "insert"
              ? "fas fa-file-plus"
              : actionName == "chuyenXuLi"
                  ? "fas fa-arrow-alt-circle-right"
                  : actionName == "kySoChuyenXuLi"
                      ? "fas fa-arrow-alt-circle-right"
                      : actionName == "banHanh" || actionName == "banHanhCaNhan"
                          ? "fas fa-check-circle"
                          : actionName == "tuChoi" ||
                          actionName == "tuChoiBanHanh" ||
                          actionName == "tuChoiGhiChuVb"
                              ? "fas fa-ban"
                              : actionName == "choBanHanh"
                                  ? "fas fa-clock"
                                  : actionName == "kethuc"
                                      ? "fas fa-calendar-check"
                                      : actionName == "thuHoi"
                                          ? "fas fa-undo"
                                          : actionName == "thuHoiBanHanh"
                                              ? "fas fa-reply-all"
                                              : actionName == "chuyenXuLiDonVi"
                                                  ? "fas fa-arrow-alt-circle-right"
                                                  : actionName == "cc"
                                                      ? "fas fa-closed-captioning"
                                                      : actionName == "hieuChinhBanHanh"
                                                          ? "fal fa-pen-square"
                                                          : actionName == "hieuChinhBanHanhCaNhan"
                                                              ? "fal fa-pen-square"
                                                              : actionName == "hieuChinh"
                                                                  ? "fal fa-file-edit"
                                                                  : actionName == "tuChoiTiepNhan"
                                                                      ? "fal fa-reply"
                                                                      : "";
    },
    classColorByActionName(actionName) {
      return actionName == "update"
          ? "color__green"
          : actionName == "insert"
              ? "color__blue"
              : actionName == "chuyenXuLi"
                  ? "color__blue"
                  : actionName == "kySoChuyenXuLi"
                      ? "color__cyan"
                      : actionName == "banHanh" || actionName == "banHanhCaNhan"
                          ? "color__green"
                          : actionName == "tuChoi" ||
                          actionName == "tuChoiBanHanh" ||
                          actionName == "tuChoiGhiChuVb"
                              ? "color__red"
                              : actionName == "choBanHanh"
                                  ? "color__blue"
                                  : actionName == "kethuc"
                                      ? "color__green"
                                      : actionName == "thuHoi"
                                          ? "color__yellow"
                                          : actionName == "thuHoiBanHanh"
                                              ? "color__yellow"
                                              : actionName == "chuyenXuLiDonVi"
                                                  ? "color__cyan"
                                                  : actionName == "cc"
                                                      ? "color__blue"
                                                      : actionName == "hieuChinhBanHanh"
                                                          ? "color__green"
                                                          : actionName == "hieuChinhBanHanhCaNhan"
                                                              ? "color__green"
                                                              : actionName == "hieuChinh"
                                                                  ? "color__blue"
                                                                  : actionName == "tuChoiTiepNhan"
                                                                      ? " color__red"
                                                                      : "";
    },
    removeUser(tagValue) {
      this.toUserIds = this.toUserIds.filter(i => i !== tagValue)
      this.checkAll = false
    },
    selectAll() {
      this.checkAll = !this.checkAll;
      if(this.checkAll) {
        this.toUserIds = this.toUsers.map(i => i.id)
      }else {
        this.toUserIds = []
      }
    }
  }
};
</script>

<style scoped>
.history-action .receiver {
  padding: 5px 7px;
  background-color: #e3e8ee;
  border-radius: 8px;
}

.panel-body .list__action__item .receiver .avatar-fake.avt {
  width: 28px;
  height: 28px;
  background-color: rgba(230, 37, 101, 0.2);
}

.full-screen {
  animation: half-to-full 0.5s;
  transition: 0.5s;
  width: 100%;
}

.half-screen {
  width: 75%;
  max-width: 420px;
  transition: 0.5s;
}

@keyframes half-to-full {
  from {
    width: 75%;
  }
  to {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/History.vue